import { connect } from 'react-redux';
import { getToken } from 'datamodel/Auth/selectors';
import UserMessage from './user-message';

const mapStateToProps = (state) => ({
  token: getToken(state),
});

export default connect(mapStateToProps)(UserMessage);
